<template>
    <div
            class="modal fade"
            id="sys_import_modal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myModalLabel"
            aria-hidden="true"
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    <h4 class="modal-title" id="myModalLabel">批量电表上传</h4>
                </div>
                <!-- modal-body-->
                <div class="modal-body">
                    <form id="sys_dlg_form" role="form" class="form-horizontal">
                        <div class="form-group">
                            <label class="col-sm-2 control-label">选择Excel2007：</label>
                            <div class="col-sm-4">
                                <input name="updataexcel2007" type="file" class="form-control file-pretty_uploadFile"/>
                            </div>
                            <label class="col-sm-2 control-label"></label>
                            <div class="col-sm-4">
                                <a href="__PUBLIC__/tpl/imptpl_ammeter.xlsx">点击下载模板示例</a>
                            </div>
                        </div>
                    </form>
                </div>
                <!-- modal-footer -->
                <div class="modal-footer">
                    <button type="button" data-dismiss="modal" class="btn btn-default">关闭</button>
                    <button type="button" data-dismiss="modal" class="btn btn-primary" @click="submitimp">上传</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  export default {
    data () {
      return {}
    },
    mounted: function () {
      $('.file-pretty_uploadFile').prettyFile()
    },
    methods: {
      submitimp: function () {
        $('#sys_dlg_form').submit(function (e) {
          var formData = new FormData(this)
          $.ajax({
            url: '__CONTROLLER__/submitimp',
            type: 'POST',
            data: formData,
            mimeType: 'multipart/form-data',
            contentType: false,
            cache: false,
            processData: false,
            success: function (data, textStatus, jqXHR) {
              var obj = eval('(' + data + ')')
              if (obj.msg == 'ok') {
                alert(obj.info)
              } else {
                error = JSON.stringify(obj.info)
                alert('上传失败！失败原因：' + error)
              }
              $('#atptable').bootstrapTable('refresh')
            }
          })
          e.preventDefault()
        })
        $('#sys_dlg_form').submit()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/ammeter/ammeterImport.vue